import { useCallback } from 'react';

export type RollbarParameters = {
  message?: string;
}

const log = (logType) => (message) => {
  const {
    Rollbar,
  } = window;

  if (Rollbar) {
    // TODO extend to support optional params if necessary
    Rollbar[logType](message);
  }
};

export const useRollbar = () => {
  const critical = log('critical');
  const debug = log('debug');
  const error = log('error');
  const info = log('info');
  const warning = log('warning');

  return {
    critical: useCallback(critical, [critical]),
    debug: useCallback(debug, [debug]),
    error: useCallback(error, [error]),
    info: useCallback(info, [info]),
    warning: useCallback(warning, [warning]),
  };
};
